import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './Navbar.css';
import versusLogo from '../assets/logos/versus-logo.svg';

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    console.log('🔥 Mobile nav toggle clicked, current state:', mobileMenuOpen);
    setMobileMenuOpen(prev => {
      const newState = !prev;
      console.log('🔥 Setting mobile nav to:', newState);
      return newState;
    });
  };

  const closeMobileMenu = () => {
    console.log('🔥 Mobile nav closing');
    setMobileMenuOpen(false);
  };

  // Body scroll lock und Chat-Hintergrund wenn mobile menu offen
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('mobile-menu-open'); // Chat in Hintergrund
    } else {
      document.body.style.overflow = '';
      document.body.classList.remove('mobile-menu-open');
    }
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('mobile-menu-open');
    };
  }, [mobileMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-logo" onClick={() => setMobileMenuOpen(false)}>
          <img src={versusLogo} alt="VersusArena" />
        </Link>
      </div>

      {/* Desktop Navigation - Hidden on mobile */}
      <div className="navbar-center">
        <ul className="navbar-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/tournaments">Tournaments</Link></li>
          <li><Link to="/games">Games</Link></li>
          <li><Link to="/versus-token">Versus Token</Link></li>
          <li><Link to="/shop">Shop</Link></li>
        </ul>
      </div>

      <div className="navbar-right">
        <ul className="navbar-auth-links">
          {user ? (
            <>
              <li>
                <Link to="/account">
                  {(user?.username && !user.username.includes('_temp_')) ? user.username : (user?.nickname || user?.email?.split('@')[0] || 'Profile')}
                </Link>
              </li>
              {(user?.isAdmin || user?.role === 'admin' || user?.role === 'master') && (
                <>
                  <li>
                    <Link to="/admin-login" style={{ color: '#00d4aa', fontWeight: 'bold' }}>
                      🚀 Admin Panel
                    </Link>
                  </li>
                </>
              )}
              <li>
                <button type="button" className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/register">Sign Up</Link></li>
            </>
          )}
        </ul>

        {/* Mobile Hamburger Button - Only visible on mobile */}
        <button 
          className="mobile-hamburger"
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu Overlay - Only visible on mobile when open */}
      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="mobile-menu-header">
              <h3>VersusArena</h3>
              <button onClick={closeMobileMenu}>✕</button>
            </div>

            {/* Navigation Links */}
            <div className="mobile-menu-links">
              {[
                { to: '/', label: '🏠 Home' },
                { to: '/tournaments', label: '🏆 Tournaments' },
                { to: '/games', label: '🎮 Games' },
                { to: '/versus-token', label: '💰 Versus Token' },
                { to: '/shop', label: '🛍️ Shop' }
              ].map(link => (
                <Link 
                  key={link.to}
                  to={link.to} 
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Auth Section */}
            <div className="mobile-menu-auth">
              {user ? (
                <>
                  <Link to="/account" onClick={closeMobileMenu}>
                    👤 {user.username || user.nickname || 'Profile'}
                  </Link>
                  {(user.isAdmin || user.role === 'admin' || user.role === 'master') && (
                    <>
                      <Link to="/admin-login" onClick={closeMobileMenu}>
                        🚀 Admin Panel
                      </Link>
                    </>
                  )}
                  <button onClick={handleLogout}>
                    🚪 Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={closeMobileMenu}>
                    🔑 Login
                  </Link>
                  <Link to="/register" onClick={closeMobileMenu}>
                    📝 Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
